import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.12));
  z-index: 2147483647;
`;
